import { create } from 'zustand';

type UnreadTabsState = {
  unreadTabIds: Set<string>;
  markTabUnread: (tabId: string) => void;
  markTabRead: (tabId: string) => void;
  clearAll: () => void;
};

export const useUnreadTabsStore = create<UnreadTabsState>((set, get) => ({
  unreadTabIds: new Set<string>(),
  markTabUnread: (tabId) => {
    const { unreadTabIds } = get();
    if (unreadTabIds.has(tabId)) {
      return;
    }
    const nextUnreadTabIds = new Set(unreadTabIds);
    nextUnreadTabIds.add(tabId);
    set({ unreadTabIds: nextUnreadTabIds });
  },
  markTabRead: (tabId) => {
    const { unreadTabIds } = get();
    if (!unreadTabIds.has(tabId)) {
      return;
    }
    const nextUnreadTabIds = new Set(unreadTabIds);
    nextUnreadTabIds.delete(tabId);
    set({ unreadTabIds: nextUnreadTabIds });
  },
  clearAll: () => set({ unreadTabIds: new Set<string>() }),
}));
